<template>
  <div
    ref="playlistContainer"
    class="playlist-container"
    :class="{
      'playlist-horizon': horizon,
      'playlist-vertical d-flex flex-wrap flex-md-column align-items-md-stretch flex-md-nowrap': !horizon}"
  >
    <template v-if="horizon">
      <div
        v-for="item in playlist"
        class="playlist-item tw-rounded-2xl"
        :class="{ 'playlist-item-current': item.id === currentVideo.id }"
        :style="{'background-image': 'url(' + item.preview_path + ')'}"
        @click="clickVideo(item)"
      >
        <div v-if="item.id === currentVideo.id" class="playlist-item-mask">
          <span class="font-white">Now Playing</span>
        </div>
        <div v-else class="playlist-item-title hint--top" :aria-label="item.title">
          <div>{{ item.title }}</div>
        </div>
      </div>
    </template>
    <template v-else>
      <div
        v-for="item in playlist"
        class="playlist-item mb-2 cursor-pointer tw-overflow-hidden tw-rounded-xl tw-w-[200px]"
        :class="{ 'playlist-item-current': item.id === currentVideo.id }"
        @click="clickVideo(item)"
      >
        <div class="playlist-preview-wrapper">
          <div class="playlist-preview" :style="{'background-image': 'url(' + item.preview_path + ')'}"></div>
          <div v-if="item.id === currentVideo.id" class="playlist-item-mask">
            <span class="text-white">Now Playing</span>
          </div>
        </div>
        <div
          v-if="item.id !== currentVideo.id"
          class="playlist-item-title"
        >
          {{ item.title }}
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import $ from 'jquery'

export default {
  name: 'Playlist',
  props: {
    playlist: {
      required: true
    },
    currentVideo: {},
    horizon: {
      type: Boolean,
      default: true
    }
  },
  emits: ['click-video'],
  mounted () {
    this.resizePlaylist()
  },
  methods: {
    clickVideo (video) {
      this.$emit('click-video', video)
    },
    resizePlaylist () {
      if (this.playlist.length === 0 || !this.horizon) {
        return
      }
      const $container = $(this.$refs.playlistContainer)
      const $items = $container.children()
      let targetWidth = 0
      $items.each(function () {
        targetWidth += $(this).outerWidth()
      })
      if (targetWidth < $container.width()) {
        $container.width(targetWidth + 'px')
      }
    },
    moveCurrentToCenter () {
      const $container = $(this.$refs.playlistContainer)
      const $current = $('.playlist-item-current')
      const $firstItem = $container.children('.playlist-item').first()

      if (this.horizon) {
        const firstItemPositionLeft = $firstItem.position().left
        const currentPositionLeft = $current.position().left
        const currentOffsetLeft = currentPositionLeft - firstItemPositionLeft
        const containerWidth = $container.width()
        const currentWidth = $current.width()
        const scrollLeft = currentOffsetLeft - containerWidth / 2 + currentWidth / 2

        $container.animate({ scrollLeft }, 500)
      } else {
        const firstItemPositionTop = $firstItem.position().top
        const currentPositionTop = $current.position().top
        const currentOffsetTop = currentPositionTop - firstItemPositionTop
        const containerHeight = $container.height()
        const currentHeight = $current.height()
        const scrollTop = currentOffsetTop - containerHeight / 2 + currentHeight / 2

        $container.animate({ scrollTop }, 500)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.playlist-container.playlist-vertical {
  max-height: 100vh;
  position: relative;
  overflow-y: scroll;
  margin: 0 auto;

  .playlist-item {
    position: relative;
    @media (max-width: 767px) {
      width: 50%;
      padding: 3px;
    }

    .playlist-preview-wrapper {
      position: relative;
      padding-bottom: 56.25%;

      &>div {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
      }
    }
    .playlist-preview {
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      background-color: #000;
    }

    .playlist-item-mask {
      background: rgba(0,0,0,0.7);
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .playlist-item-title {
      position: absolute;
      text-align: center;
      color: #fff;
      background: rgba(0,0,0,0.7);
      padding: 3px;
      left: 0;
      bottom: 0;
      font-size: 12px;
      width: 100%;
    }
  }
}

.playlist-container.playlist-horizon {
  position: relative;
  overflow-x: scroll;
  display: flex;
  flex-direction: row;
  margin: 5px auto;
  width: 80%;
  @media (max-width: 480px) {
    width: 100%;
    margin-top: 10px;
  }
  border: solid 1px #ccc;
  align-items: center;

  .playlist-item {
    width: 160px;
    height: 90px;
    background-size: cover;
    background-position: center;
    margin: 5px;
    position: relative;
    cursor: pointer;
    display: flex;
    flex-shrink: 0;

    .playlist-item-mask {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: rgba(0,0,0,0.7);
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .playlist-item-title {
      text-align: center;
      color: #fff;
      background: rgba(0,0,0,0.7);
      align-self: flex-end;
      padding: 3px;
      width: 100%;
      &>div {
        width: 100%;
        font-size: 12px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>
